import React from "react";
import { useAccount } from "../services/hooks/use_account";

export const Account = React.createContext({} as ReturnType<typeof useAccount>);
